import * as React from 'react';
import {
  BookIcon,
  BookOpenIcon,
  BoxIcon,
  CircuitBoardIcon,
  CodeIcon,
  CuboidIcon,
  FileBarChartIcon,
  LayoutIcon,
  PlayIcon,
  SendHorizonalIcon
} from 'lucide-react';

import { baseUrl, routes } from '@workspace/routes';
import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  TikTokIcon,
  XIcon
} from '@workspace/ui/components/brand-icons';

export const MENU_LINKS = [
  {
    title: 'Lite',
    href: routes.marketing.Index,
    external: false
  },
  {
    title: 'Cloud',
    href: routes.marketing.Cloud,
    external: false
  },
  {
    title: 'Resources',
    items: [
      {
        title: 'Contact',
        description: 'Reach out for assistance',
        icon: <SendHorizonalIcon className="size-5 shrink-0" />,
        href: routes.marketing.Contact,
        external: false
      },
      {
        title: 'Help Docs',
        description: 'Learn how to use Tippler lite',
        icon: <BookOpenIcon className="size-5 shrink-0" />,
        href: routes.marketing.Docs,
        external: false
      }
    ]
  },

  // {
  //   title: 'Pricing',
  //   href: routes.marketing.Pricing,
  //   external: false
  // },
  // {
  //   title: 'Blog',
  //   href: routes.marketing.Blog,
  //   external: false
  // },
  // {
  //   title: 'Story',
  //   href: routes.marketing.Story,
  //   external: false
  // }
];

export const FOOTER_LINKS = [
  {
    title: 'Resources',
    links: [
      { name: 'Contact', href: routes.marketing.Contact, external: false },
      // { name: 'Roadmap', href: routes.marketing.Roadmap, external: true },
      { name: 'Docs', href: routes.marketing.Docs, external: false },
      // { name: 'API Reference', href: baseUrl.PublicApi, external: true }
    ]
  },
  // {
  //   title: 'About',
  //   links: [
  //     { name: 'Story', href: routes.marketing.Story, external: false },
  //     { name: 'Blog', href: routes.marketing.Blog, external: false },
  //     { name: 'Careers', href: routes.marketing.Careers, external: false }
  //   ]
  // },
  {
    title: 'Legal',
    links: [
      {
        name: 'Terms of Use',
        href: routes.marketing.TermsOfUse,
        external: false
      },
      {
        name: 'Privacy Policy',
        href: routes.marketing.PrivacyPolicy,
        external: false
      },
      {
        name: 'Cookie Policy',
        href: routes.marketing.CookiePolicy,
        external: false
      }
    ]
  }
];

export const SOCIAL_LINKS = [
  {
    name: 'X (formerly Twitter)',
    href: '~/',
    icon: <XIcon className="size-4 shrink-0" />
  },
  {
    name: 'LinkedIn',
    href: '~/',
    icon: <LinkedInIcon className="size-4 shrink-0" />
  },
  {
    name: 'Facebook',
    href: '~/',
    icon: <FacebookIcon className="size-4 shrink-0" />
  },
  {
    name: 'Instagram',
    href: '~/',
    icon: <InstagramIcon className="size-4 shrink-0" />
  },
  {
    name: 'TikTok',
    href: '~/',
    icon: <TikTokIcon className="size-4 shrink-0" />
  }
];

export const DOCS_LINKS = [
  {
    title: 'Getting Started',
    icon: <CuboidIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Quick Start',
        href: '/docs/get-started/quick-start',
        items: []
      },
      {
        title: 'Player Guide',
        href: '/docs/get-started/player-guide',
        items: []
      }
    ]
  },
  {
    title: 'User Guide',
    icon: <BookIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Media Management',
        href: '/docs/user_guide/media-guide',
        items: []
      },
      {
        title: 'Screen Management',
        href: '/docs/user_guide/screens-guide',
        items: []
      },
      {
        title: 'Publications Guide',
        href: '/docs/user_guide/publications-guide',
        items: []
      },
      {
        title: 'Schedule Guide',
        href: '/docs/user_guide/schedule-guide',
        items: []
      }
    ]
  }
];
